export const colors = {
  background: "#292929",
  white: "#ededed",
};
